import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAntiAgingAndAcneGlyphSecondary from './svgs/AntiAgingAndAcneGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var antiAgingAndAcneGlyph = (props => useIcon(null, SvgAntiAgingAndAcneGlyphSecondary, props));

export { antiAgingAndAcneGlyph as default };
